import type { Entity, VaultKind } from '@onefootprint/request-types/dashboard';
import constate from 'constate';

type UseEntitiesContext = {
  data?: Entity[];
  errorMessage?: string;
  initialSearch?: string;
  isPending: boolean;
  kind: VaultKind;
  onRowClick: (entity: Entity, event: React.MouseEvent<HTMLElement>) => void;
  onSearchChange: (search: string) => void;
};

const useLocalEntitiesContext = (options: UseEntitiesContext) => options;

const [Provider, useEntitiesContext] = constate(useLocalEntitiesContext);

export default Provider;
export { useEntitiesContext };
